import { toast } from 'react-toastify';
import { api } from '~/Api';
import { contextProject } from '~/Context/contextProject';
import { loadModel } from './contentEditorManager';
import { Observable } from '~/Utils/observable';
import { _contentsManager } from '~/Services/Studio/studioScene';
import { CONTEXT, context } from '~/Services/Environment/environment';
import { apiSocket } from '~/Api/apiSocket';
import { ContentModel } from '~/Scene/Content/contentModel';

export enum ContentEvent {
    UploadStart,
    UploadProgress,
    UploadEnd,
    TextureEnd
}

class ContentObservable extends Observable<ContentEvent, number | string> {
    constructor() {
        super('CONTENT');
        apiSocket.executeOnConnect((socket) => {
            socket.on('compression', (response) => {
                this.notify(ContentEvent.UploadProgress, response.percentage);
            });
        });
    }
}

export const contentObservable = new ContentObservable();

export const getModels = () => _contentsManager.getContentModels();

export const getLights = () => _contentsManager.getContentLights();

const uploadModelFile = async (file: string | Blob) => new Promise<string>((resolve, reject) => {
    contentObservable.notify(ContentEvent.UploadStart, 0);
    const modelUploadUrl = `model/import?source=file&projectid=${contextProject.getProjectId()}`;
    api.upload(modelUploadUrl, file, (res) => {
        if (res.success === false) {
            console.warn('Error while uploading model:', res.error);
            toast.error(`Error while uploading model: ${res.error}`);
            reject();
        } else {
            resolve(res.url);
        }
    });
});

export const uploadModel = async (file: string | Blob) => {
    const newModelUrl = await uploadModelFile(file);
    loadModel(newModelUrl);
};

export const uploadAndRefreshModel = async (file: string | Blob, model: ContentModel) => {
    const newModelUrl = await uploadModelFile(file);
    model.loadModel(newModelUrl);
};

export const uploadTexture = async (file: string | Blob) => {
    contentObservable.notify(ContentEvent.UploadStart, 0);
    if (context === CONTEXT.LOCAL) {
        const reader = new FileReader();
        reader.onload = () => {
            const base64 = reader.result;
            contentObservable.notify(ContentEvent.TextureEnd, base64);
            contentObservable.notify(ContentEvent.UploadEnd, 0);
        };
        reader.readAsDataURL(file);
    } else {
        const textureUploadUrl = `model/upload_texture?projectid=${contextProject.getProjectId()}`;
        api.upload(textureUploadUrl, file, (res) => {
            if (res.success === false) {
                console.warn('Error while uploading texture:', res.error);
            } else {
                contentObservable.notify(ContentEvent.TextureEnd, res);
                contentObservable.notify(ContentEvent.UploadEnd, 0);
            }
        });
    }
};
